import { Link } from "react-router-dom"

export function FeaturedTexts({ heading, description }) {
    return (
        <>
            <h4 className="text-white">{heading}</h4>
            <p className="text-white">
                {description}
            </p>
            <h6><Link to="/shop" className="text-white">Shop Now</Link></h6>
        </>
    )
}